import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../config';
import './Footer.css';

const Footer = () => {

  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Свяжитесь с нами</h3>
            <div className="footer-links">
              <motion.a
                href={config.telegram.channel}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                📢 Telegram канал
              </motion.a>
              <motion.a
                href={config.telegram.manager}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                💬 Менеджер
              </motion.a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 AirRoom Vape Shop. Все права защищены.</p>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;

